var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dropdown-container"}},[_c('label',{staticClass:"dropdown-button clickable",on:{"click":_vm.toggle}},[_c('font-awesome-icon',{attrs:{"icon":_vm.objectIcon(),"size":"2x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }